import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import DataTable from "react-data-table-component";
import UserHeader from "./UserHeader";
import axios from "../axiosInstance";
import { ColorRing } from "react-loader-spinner";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "@mui/icons-material/Edit";
import PreviewIcon from "@mui/icons-material/Preview";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

var images = "";
var arr1 = [];
var bedroomData = [];
var images1 = "";
var arr2 = [];
var updateGallery;
var dynamicObj = [];
var dynamicObj1 = [];
const PropertiesList = () => {
  const [charValue, setCharValue] = useState(0);
  const [saveCount, setSaveCount] = useState(0);
  const [propertyRecentSection, setPropertyRecentSection] = useState("");
  const [propertyPopularSection, setPropertyPopularSection] = useState("");
  const [AddCount, setAddCount] = useState(0);
  const myForm = useRef(null);
  const [propertyData, setPropertyData] = useState();
  const [oldGalleryImages, setOldGalleryImages] = useState();
  const [oldPropertyBedroom, setOldPropertyBedroom] = useState();
  const [oldFloorPlanImages, setOldFloorPlanImages] = useState();
  const [appendDiv, setAppendDiv] = useState([]);
  const [appendDiv1, setAppendDiv1] = useState([]);
  const [appendDiv2, setAppendDiv2] = useState([]);
  const [attachment, setAttachment] = useState(" ");
  const [seeImg2, setSeeImg2] = useState();
  const [count, setCount] = useState(1);
  const [count1, setCount1] = useState(1);
  const [count2, setCount2] = useState(0);
  const [visible, setVisible] = useState(false);
  const token = sessionStorage.getItem("token");
  const [name, setName] = useState();
  const [propertyBannerImg, setPropertyBannerImg] = useState();
  const [propertyImg, setPropertyImg] = useState();
  const [price, setMinPrice] = useState();
  const [max_price, setMaxPrice] = useState();
  const [address, setAddress] = useState();
  const [lat, setLat] = useState();
  const [lng, setLng] = useState();
  const [pdetails, setPDetails] = useState("");
  const [beds, setBeds] = useState();
  const [bath, setBath] = useState();
  const [parking, setParking] = useState();
  const [min_area, setMinArea] = useState();
  const [max_area, setMaxArea] = useState();
  const [areaUnit, setAreaUnit] = useState();
  const [floorImg, setFloorImg] = useState();
  const [propertyId, setPropertyId] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  var myFloorType = [];
  const [removedImg, setRemovedImg] = useState([]);
  const [galleryId, setGalleryId] = useState();
  const [galleryName, setGalleryName] = useState();
  const [galleryImage, setGalleryImage] = useState();
  const [typeList, setTypeList] = useState();
  const [planList, setPlanList] = useState();
  const [typeArr, setTypeArr] = useState();
  const [planId, setPlanId] = useState(1);
  const [brochureImage, setBrochureImage] = useState();
  const [builder, setBuilder] = useState();
  const [builderList, setBuilderList] = useState();
  const [shortDesc, setShortDesc] = useState();
  const [propertyVideo, setPropertyVideo] = useState();
  const [propertyStatus, setPropertyStatus] = useState();
  const [updateBedroomType, setUpdateBedroomType] = useState();
  const [updateBedroomName, setUpdateBedroomName] = useState();
  const [updateBedroomArea, setUpdateBedroomArea] = useState();
  const [updateBedroomPrice, setUpdateBedroomPrice] = useState();
  const [updateBedroomStatus, setUpdateBedroomStatus] = useState();
  const [seoTitle, setSeoTitle] = useState();
  const [tags, setTags] = useState();
  const [seoDescription, setSeoDescription] = useState();

  // const [noOfBedroom, setNoOfBedroom] = useState()
  // const [bedroomType, setBedroomType] = useState([''])
  // const [bedroomTypeText, setBedroomTypeText] = useState()
  // const [bedroomArea, setBedroomArea] = useState()
  // const [bedroomPrice, setBedroomPrice] = useState()
  const [amenities, setAmenitites] = useState([]);
  // const [floor_type, setFloorType] = useState([])
  const [floorTypeArray, setFloorTypeArray] = useState("");
  // const [floorBedroom, setFloorBedroom] = useState()

  var amenitiesList = useRef([]);
  const [bedroomArray, setBedroomArray] = useState({
    name: "",
    type: "",
    area: "",
    price: "",
  });

  const columns = [
    // {
    //   name: "Plan Id",
    //   selector: (row) => row.plan_id,
    //   width: "70px",
    // },
    {
      name: "Builder",
      selector: (row) => row?.builderData?.name,
      width: "88px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      width: "200px",
    },
    // {
    //     name: "Action",
    //     selector: (row) => <button className="btn btn-danger" data-toggle="modal" data-target="#exampleModal4" onClick={() => collectData(row)}>Edit</button>,
    //     width: '100px'
    // },
    {
      name: "Category",
      selector: (row) => row.category,
      width: "90px",
    },
    {
      name: "Image",
      selector: (row) => (
        <div>
          <img
            src={"https://api.divinebricks.com" + row.image}
            style={{ width: "88px", height: "50px" }}
          />
        </div>
      ),
    },
    // {
    //     name: "Bedrooms",
    //     selector: (row) => row.min_beds,
    // },
    // {
    //     name: "Bathrooms",
    //     selector: (row) => row.min_bath,
    // },
    {
      name: "Address",
      selector: (row) => row.address,
      width: "200px",
    },
    // {
    //     name: "Area",
    //     selector: (row) => <div>{row.min_area} {row.area_unit}</div>,
    //     width: '140px'
    // },
    {
      name: "Amount",
      selector: (row) => "$" + row.price,
    },
    {
      name: "Date",
      selector: (row) => moment(row.createdAt).format("DD-MM-YYYY"),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => (
        <div
          className={
            row.is_status == "booked"
              ? "badge badge-danger p-2"
              : "badge badge-success p-2"
          }
        >
          {row.is_status}
        </div>
      ),
      width: "80px",
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <button
            className="mx-2"
            data-toggle="modal"
            data-target="#exampleModal6"
            onClick={() => collectData(row)}
            style={{
              padding: "10px",
              lineHeight: "20px",
              border: "none",
              background: "transparent",
            }}
          >
            <PreviewIcon />
          </button>
          <button
            data-toggle="modal"
            data-target="#exampleModal4"
            onClick={() => collectData(row)}
            style={{
              padding: "10px",
              lineHeight: "20px",
              border: "none",
              background: "transparent",
            }}
          >
            <EditIcon style={{ width: "0.8em" }} />
          </button>
        </div>
      ),
      width: "160px",
    },
  ];

  function getCharLength(event) {
    setCharValue(event.target.value.length);
  }

  function handleToggle(e) {
    const { value, checked } = e.target;
    if (checked) {
      setAmenitites((pre) => [...pre, value]);
    } else {
      setAmenitites((pre) => {
        return [...pre.filter((skill) => skill !== value)];
      });
    }
  }

  function handleGalleryId(data) {
    setGalleryId(data.id);
    setGalleryName(data.name);
    setGalleryImage(data.img_url);
    //console.log(data, "dataId");
  }

  const collectData = (row) => {
    //console.log(">>>row>>>", row);
    axios
      .post(
        `api/users/get-property-gallery`,
        {
          propertyId: row.id.toString(),
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((resp) => {
        setOldGalleryImages(resp.data.result?.gallery);
        setOldFloorPlanImages(resp.data.result?.floorplans);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });

    axios
      .post(
        `api/users/get-property-bedroom`,
        {
          propertyId: row.id.toString(),
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((resp) => {
        setOldPropertyBedroom(resp.data.result);
        // setUpdateBedroomType(),
        // setUpdateBedroomName(),
        // setUpdateBedroomArea(),
        // setUpdateBedroomPrice(),
        // setUpdateBedroomStatus('active')
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
    //console.log(row);
    setPropertyId(row.id);
    setName(row.name);
    setPropertyBannerImg(row.banner);
    setPropertyImg(row.image);
    setMinPrice(row.price);
    setMaxPrice(row.max_price);
    setAddress(row.address);
    setCity(row.city);
    setState(row.state);
    setAddress(row.address);
    setAmenitites(row.ameties);
    setPlanId(row.id);
    setTypeArr(row.typeArr);
    setLat(row.lat);
    setLng(row.lng);
    setShortDesc(row.short_details);
    setBrochureImage(row.brochure);
    setBuilder(row.builderId);
    setPDetails(row.pdetails);
    setFloorImg(row.floor_plans);
    setBeds(row.min_beds);
    setBath(row.min_bath);
    setParking(row.parking);
    setMinArea(row.min_area);
    setMaxArea(row.max_area);
    setPropertyStatus(row.is_status);
    setPropertyRecentSection(row.recent_property);
    setPropertyPopularSection(row.populer_property);
    setPropertyVideo(row.video_link);
  };

  function emptyStates() {
    arr1 = [];
    arr2 = [];
    setCount2(0);
  }

  function handleOnChange(e) {
    setFloorTypeArray((pre) => [...pre, e.target.value]);
  }
  const fetchData = () => {
    axios
      .get(`api/users/get-property-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setPropertyData(resp.data.result?.propertyList);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });

    axios
      .get(`api/users/get-home-ameties-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        amenitiesList.current = [];
        for (var i = 0; i < resp.data.result.length; i++) {
          amenitiesList.current.push(resp.data.result[i].name);
        }
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });

    axios
      .get(`api/admins/get-admin-builder-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setBuilderList(resp.data.result.docs);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });

    axios
      .get(`api/users/get-type-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setTypeList(resp.data.result);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });

    axios
      .get(`api/users/get-plan-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setPlanList(resp.data.result);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  function handleFloorArray(e) {
    const { name, value } = e.target;
    setBedroomArray((prev) => {
      return { ...prev, [name]: value };
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    var obj1 = {};
    var obj2 = {};
    var obj3 = {};
    var myImages = [];
    var myImages1 = [];
    var myImages2 = [];
    for (var i = 0; i < arr1.length; i++) {
      myImages[i] = arr1[i];
      obj1[i] = { name: name, img_url: myImages[i] };
      dynamicObj.push(obj1[i]);
    }
    for (var i = 0; i < arr2.length; i++) {
      myImages1[i] = arr2[i];
      obj2[i] = { type: floorTypeArray[i], img_url: myImages1[i] };
      dynamicObj1.push(obj2[i]);
    }
    // setVisible(true);
    axios
      .post(
        `api/users/add-property`,
        {
          name: name,
          plan_id: planId?.toString(),
          banner: propertyBannerImg,
          image: propertyImg,
          price: price,
          max_price: max_price,
          builderId: builder?.toString(),
          address: address,
          ameties: amenities?.toString(),
          city: city,
          state: state,
          typeArr: typeArr,
          brochure: brochureImage,
          lat: "50",
          lng: "50",
          pdetails: pdetails,
          floor_plans: dynamicObj1,
          min_beds: beds?.toString(),
          min_bath: bath?.toString(),
          parking: parking,
          min_area: min_area,
          max_area: max_area,
          area_unit: "Square Feet",
          gallery: dynamicObj,
          short_details: shortDesc,
          video_link: propertyVideo,
          bedrooms: bedroomData,
          recent_property: propertyRecentSection,
          populer_property: propertyPopularSection,
          seo_title: seoTitle,
          seo_description: seoDescription,
          seo_keywords: tags,
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((resp) => {
        setVisible(false);
        if (!resp.data.success) {
          toast.error(resp.data.msg, { toastId: "e1" });
        }
        if (resp.data.success) {
          toast(resp.data.msg, { toastId: "s1" });
          $("[data-dismiss=modal]").trigger({ type: "click" });
          fetchData();
        }
        dynamicObj = [];
        dynamicObj1 = [];
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
  };

  const editForm = (e) => {
    e.preventDefault();
    setVisible(true);
    axios
      .post(
        `api/users/update-property`,
        {
          propertyId: propertyId.toString(),
          name: name,
          // plan_id: planId.toString(),
          banner: propertyBannerImg,
          image: propertyImg,
          price: price,
          max_price: max_price,
          brochure: brochureImage,
          builderId: builder.toString(),
          address: address,
          city: city,
          state: state,
          ameties: amenities,
          typeArr: typeArr,
          lat: "50",
          lng: "50",
          pdetails: pdetails,
          floor_plans: floorImg,
          min_beds: beds.toString(),
          min_bath: bath.toString(),
          parking: parking,
          min_area: min_area.toString(),
          max_area: max_area.toString(),
          area_unit: "Square Feet",
          short_details: shortDesc,
          video_link: propertyVideo,
          is_status: propertyStatus,
          recent_property: propertyRecentSection,
          populer_property: propertyPopularSection,
          seo_title: seoTitle,
          seo_keywords: tags,
          seo_description: seoDescription,
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((resp) => {
        setVisible(false);
        if (!resp.data.success) {
          toast.error(resp.data.msg, { toastId: "e1" });
        }
        if (resp.data.success) {
          toast(resp.data.msg, { toastId: "s1" });
          $("[data-dismiss=modal]").trigger({ type: "click" });
        }
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
  };

  function updateBedrooms(id) {
    setVisible(true);
    axios
      .post(
        `api/users/update-property-bedroom`,
        {
          bedId: id.toString(),
          type: updateBedroomType,
          name: updateBedroomName,
          area: updateBedroomArea,
          price: updateBedroomPrice,
          is_status: "active",
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((resp) => {
        setVisible(false);
        if (!resp.data.success) {
          toast.error(resp.data.msg, { toastId: "e1" });
        }
        if (resp.data.success) {
          toast(resp.data.msg, { toastId: "s1" });
        }
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
  }

  $(document).on("click", ".remove-btn", function () {
    $(this).parent().remove();
    // setRemovedImg.push($(this).parent().find('img').attr('id'))
    setCount(count - 1);
  });

  const addDiv = () => {
    var val = [...appendDiv, []];
    setAppendDiv(val);
    appendDiv.push(`hello`);
    setCount(count + 1);
  };
  const addDiv1 = () => {
    var val = [...appendDiv1, []];
    setAppendDiv1(val);
    appendDiv1.push(` `);
    setCount1(count1 + 1);
  };

  const addDiv2 = () => {
    if (saveCount != AddCount) {
      toast.error("Please save previous data");
      return;
    }
    setAddCount(AddCount + 1);
    var val = [...appendDiv2, []];
    setAppendDiv2(val);
    appendDiv2.push(`hello`);
    // bedroomData.push(bedroomArray)
    // appendDiv.push(`<div className="col-md-4 copy-div mb-3"><input className="form-control imageUpload2" type="file" id="myfile" name="myfile" onChange={imageUpload2} /><button className="btn btn-danger remove-btn">-</button><br /> <img className="upload-img" id="output${count}" src={"https://api.divinebricks.com" + attachment} alt="your image" /></div>`)
    setCount2(count2 + 1);
  };
  function handleFloorTypes() {
    bedroomData.push(bedroomArray);
  }
  function saveArr() {
    if (saveCount != AddCount - 1) {
      toast.error("Please add new block");
      return;
    }
    setSaveCount(saveCount + 1);
    bedroomData.push(bedroomArray);
  }

  const imageUpload2 = async (event) => {
    var id = $(event.target).parent().find("img").attr("id");
    setSeeImg2("visible");
    var output1 = document.getElementById(id);
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile2(event.target.files[0]);
  };

  function uploadFile2(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        arr1.push(resp.data.result.image_url);
        images = resp.data.result.image_url;
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload16 = async (event) => {
    var id = $(event.target).parent().find("img").attr("id");
    setSeeImg2("visible");
    var output1 = document.getElementById(id);
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile16(event.target.files[0], "Floor Plans");
  };

  function uploadFile16(file, type) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        arr2.push(resp.data.result.image_url);
        images1 = resp.data.result.image_url;
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload20 = async (event) => {
    var id = $(event.target).parent().find("img").attr("id");
    var output1 = document.getElementById(id);
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile20(event.target.files[0], "Gallery");
  };
  const imageUpload21 = async (event) => {
    var id = $(event.target).parent().find("img").attr("id");
    var output1 = document.getElementById(id);
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile20(event.target.files[0], "Floor Plans");
  };

  function uploadFile20(file, type) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        // setAttachment(resp.data.result.img_url)
        setVisible(false);
        axios
          .post(
            `api/users/add-property-gallery`,
            {
              type: type,
              propertyId: propertyId.toString(),
              name: "img",
              img_url: resp.data.result.image_url,
            },
            {
              headers: {
                "x-access-token": token,
              },
            }
          )
          .then((resp) => {
            setVisible(false);
            // setPropertyImg(resp.data.result.image_url)
          })
          .catch((err) => {
            console.log("eerr", err);
            setVisible(false);
          });
        arr1.push(resp.data.result.image_url);
        images = resp.data.result.image_url;
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload10 = async (event) => {
    var output1 = document.getElementById("output_image");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile10(event.target.files[0], "Gallery");
  };

  function uploadFile10(file, type) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);

    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        axios
          .post(
            `api/users/update-property-gallery`,
            {
              galleryId: galleryId.toString(),
              type: type,
              name: galleryName,
              img_url: resp.data.result.image_url,
            },
            {
              headers: {
                "x-access-token": token,
              },
            }
          )
          .then((resp) => {
            setVisible(false);
            if (resp.data.success) {
              $("[data-dismiss=modal]").trigger({ type: "click" });
              toast.success(resp.data.msg, { toastId: "succ1" });
              axios
                .post(
                  `api/users/get-property-gallery`,
                  {
                    propertyId: propertyId.toString(),
                  },
                  {
                    headers: {
                      "x-access-token": token,
                    },
                  }
                )
                .then((resp) => {
                  setOldGalleryImages(resp.data.result?.gallery);
                })
                .catch((err) => {
                  console.log(err);
                  setVisible(false);
                });
            } else {
              toast.error(resp.data.msg, { toastId: "erro1" });
            }
            setPropertyImg(resp.data.result.image_url);
          })
          .catch((err) => {
            console.log("eerr", err);
            setVisible(false);
          });
        arr1.push(resp.data.result.image_url);
        images = resp.data.result.image_url;
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload9 = async (event) => {
    var output1 = document.getElementById("output_image");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile100(event.target.files[0], "Floor Plans");
  };

  function uploadFile100(file, type) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    axios
      .get(`api/users/get-property-list`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setPropertyData(resp.data.result?.propertyList);
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(`api/users/upload-a-document`, formData, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((resp) => {
        setVisible(false);
        axios
          .post(
            `api/users/update-property-gallery`,
            {
              galleryId: galleryId.toString(),
              type: type,
              name: galleryName,
              img_url: resp.data.result.image_url,
            },
            {
              headers: {
                "x-access-token": token,
              },
            }
          )
          .then((resp) => {
            setVisible(false);
            if (resp.data.success) {
              $("[data-dismiss=modal]").trigger({ type: "click" });
              toast.success(resp.data.msg, { toastId: "succ1" });
              axios
                .post(
                  `api/users/get-property-gallery`,
                  {
                    propertyId: propertyId.toString(),
                    type: type,
                  },
                  {
                    headers: {
                      "x-access-token": token,
                    },
                  }
                )
                .then((resp) => {
                  setOldFloorPlanImages(resp.data.result?.floorplans);
                })
                .catch((err) => {
                  console.log(err);
                  setVisible(false);
                });
            } else {
              toast.error(resp.data.msg, { toastId: "erro1" });
            }
            setPropertyImg(resp.data.result.image_url);
          })
          .catch((err) => {
            console.log("eerr", err);
            setVisible(false);
          });
        arr2.push(resp.data.result.image_url);
        images = resp.data.result.image_url;
      })
      .catch((err) => {
        console.log(err);
        setVisible(false);
      });
  }

  const imageUpload1 = async (event) => {
    setSeeImg2("visible");
    var output1 = document.getElementById("output_image");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile1(event.target.files[0]);
  };

  function uploadFile1(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        setPropertyImg(resp.data.result.image_url);
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }
  const imageUpload0 = async (event) => {
    setSeeImg2("visible");
    var output1 = document.getElementById("output_banner_image");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile0(event.target.files[0]);
  };

  function uploadFile0(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        setPropertyBannerImg(resp.data.result.image_url);
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload11 = async (event) => {
    setSeeImg2("visible");
    var output1 = document.getElementById("output_brochure_image");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile11(event.target.files[0]);
  };

  function uploadFile11(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        setBrochureImage(resp.data.result.image_url);
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }

  const imageUpload3 = async (event) => {
    setSeeImg2("visible");
    var output1 = document.getElementById("output1");
    output1.src = URL.createObjectURL(event.target.files[0]);
    output1.onload = function () {
      URL.revokeObjectURL(output1.src); // free memory
    };
    await uploadFile3(event.target.files[0]);
  };

  function uploadFile3(file) {
    setVisible(true);
    const formData = new FormData();
    formData.append("files", file);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(
        `api/users/upload-a-document`,
        formData,
        {
          headers: {
            "x-access-token": token,
          },
        },
        {
          timeout: 1000 * 2,
        }
      )
      .then((resp) => {
        setVisible(false);
        setFloorImg(resp.data.result.image_url);
      })
      .catch((err) => {
        alert(err.network);
        setVisible(false);
      });
  }
  const img =
    "data:image/png;base64,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";
  return (
    <>
      {visible ? <div className="screen-overlay"></div> : ""}
      <ColorRing
        visible={visible}
        ariaLabel="loading"
        wrapperclassName="loader-spinner"
      />
      <UserHeader />
      <div className="row">
        <div className="col-lg-12 col-md-12">
          <div className="card">
            <div
              className="card-header"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h4 className="card-title" style={{ textAlign: "left" }}>
                Properties List
              </h4>
              <button
                className="btn btn-danger"
                data-toggle="modal"
                data-target="#exampleModal"
                onClick={emptyStates}
              >
                Add Property
              </button>
            </div>
            <div className="card-body">
              <div className="table-responsive export-button-table">
                <DataTable
                  pagination={true}
                  columns={columns}
                  data={propertyData}
                  paginationServer={true}
                  paginationRowsPerPageOptions={[10, 50, 100, 500]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Property Details
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body add-property-modal">
                <div className="row admin-property-add">
                  <div className="col-md-4 mb-4 d-none">
                    <label>
                      Select Plan <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      value={planId}
                      onChange={(e) => setPlanId(e.target.value)}
                      required={"required"}
                    >
                      <option value={""}>Select Type</option>
                      {planList?.map((data, index) => {
                        return (
                          <option key={index} value={data.id}>
                            {data.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>
                      Select Builder <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      value={builder}
                      onChange={(e) => setBuilder(e.target.value)}
                      required={"required"}
                    >
                      <option value={""}>Select Builder</option>
                      {builderList?.map((data, index) => {
                        return (
                          <option key={index} value={data.id}>
                            {data.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>
                      Property Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Property Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required={"required"}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>
                      Select Type <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      value={typeArr}
                      onChange={(e) => setTypeArr(e.target.value)}
                      required
                    >
                      <option value={""}>Select Type</option>
                      {typeList?.map((data, index) => {
                        return (
                          <option key={index} value={data.name}>
                            {data.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>
                      Property Image <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={imageUpload1}
                      required
                    />
                    <img
                      id="output_image"
                      alt="your image"
                      style={{
                        height: "100px",
                        width: "100px",
                        marginTop: "10px",
                        objectFit: "cover",
                        display: "none",
                      }}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>
                      Property Banner Image{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={imageUpload0}
                      required
                    />
                    <img
                      id="output_banner_image"
                      alt="your image"
                      style={{
                        height: "100px",
                        width: "100px",
                        marginTop: "10px",
                        objectFit: "cover",
                        display: "none",
                      }}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Property Brochure Image</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={imageUpload11}
                    />
                    <img
                      id="output_brochure_image"
                      alt="your image"
                      style={{
                        height: "100px",
                        width: "100px",
                        marginTop: "10px",
                        objectFit: "cover",
                        display: "none",
                      }}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Property Video</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Property Video Link"
                      value={propertyVideo}
                      onChange={(e) => setPropertyVideo(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter Gallery Images</label>
                    <br />
                    <button
                      type="button"
                      className="btn btn-danger"
                      data-toggle="modal"
                      data-target="#exampleModal2"
                      onClick={() => {
                        console.log(arr1);
                      }}
                    >
                      Upload
                    </button>
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter Floor Plans Images</label>
                    <br />
                    <button
                      type="button"
                      className="btn btn-danger"
                      data-toggle="modal"
                      data-target="#exampleModal7"
                    >
                      Upload
                    </button>
                    {/* <input type="file" className="form-control" placeholder="Enter Floor Plans Image" onChange={imageUpload3} />
                                    <img id="output1" alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', display: 'none' }} /> */}
                  </div>

                  <div className="col-md-4 mb-4">
                    <label>Enter Floor Type</label>
                    <br />
                    <button
                      type="button"
                      className="btn btn-danger"
                      data-toggle="modal"
                      data-target="#exampleModal8"
                    >
                      Upload
                    </button>
                    {/* <input type="file" className="form-control" placeholder="Enter Floor Plans Image" onChange={imageUpload3} />
                                    <img id="output1" alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', display: 'none' }} /> */}
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter Min Price</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Price"
                      value={price}
                      onChange={(e) => setMinPrice(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter Max Price</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Price"
                      value={max_price}
                      onChange={(e) => setMaxPrice(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter No of Bedrooms</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Bedrooms"
                      value={beds}
                      onChange={(e) => setBeds(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter No of Bathrooms</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Bathrooms"
                      value={bath}
                      onChange={(e) => setBath(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter Property Address</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Property Address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter City</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Property Address"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter State</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Property Address"
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter Parking Facility</label>
                    <select
                      className="form-control"
                      value={parking}
                      onChange={(e) => setParking(e.target.value)}
                    >
                      <option disabled selected>
                        Parking Available
                      </option>
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                    </select>
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter Min Property Size (Squ.. Feet)</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Property Size"
                      value={min_area}
                      onChange={(e) => setMinArea(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter Max Property Size (Squ.. Feet)</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Property Size"
                      value={max_area}
                      onChange={(e) => setMaxArea(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4 mb-4">
                    <label> Property Status</label>
                    <select className="form-control">
                      <option value={""}>Select Status</option>
                      <option>Active</option>
                      <option>Inactive</option>
                    </select>
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter Recent Property Section</label>
                    <select
                      className="form-control"
                      value={propertyRecentSection}
                      onChange={(e) => setPropertyRecentSection(e.target.value)}
                    >
                      <option value={""} disabled selected>
                        Recent Property
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div className="col-md-4 mb-4">
                    <label>Enter Popular Property Section</label>
                    <select
                      className="form-control"
                      value={propertyPopularSection}
                      onChange={(e) =>
                        setPropertyPopularSection(e.target.value)
                      }
                    >
                      <option value={""} disabled selected key={0}>
                        Popular Property
                      </option>
                      <option value="Yes" key={1}>
                        Yes
                      </option>
                      <option value="No" key={2}>
                        No
                      </option>
                    </select>
                  </div>
                  <div
                    className="d-flex w-100 container mb-3"
                    style={{ flexWrap: "wrap", columnGap: "20px" }}
                  >
                    {amenitiesList.current?.map((data) => {
                      return (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <input
                            id="check-3"
                            type="checkbox"
                            name="check"
                            style={{ marginRight: "10px" }}
                            value={data}
                            onChange={handleToggle}
                          />
                          <label
                            htmlFor="check-3"
                            style={{ marginBottom: "0", paddingBottom: "0" }}
                          >
                            {data}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                  <div className="col-md-12 mb-3" style={{ textAlign: "left" }}>
                    <label>Property Short Description</label>
                    <textarea
                      maxLength="255"
                      id="text-lim"
                      className="form-control"
                      placeholder="Enter Property Short Description"
                      value={shortDesc}
                      onChange={(e) => {
                        setShortDesc(e.target.value);
                        getCharLength(e);
                      }}
                      required="required"
                    ></textarea>
                    <p style={{ color: "red", marginBottom: "0" }}>
                      Max Characters {charValue}/255
                    </p>
                  </div>
                  <div className="col-md-12 mb-4" style={{ textAlign: "left" }}>
                    <label>Enter Property Details</label>
                    <ReactQuill
                      theme="snow"
                      value={pdetails}
                      onChange={(value) => setPDetails(value)}
                    />
                    {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                  </div>
                  <div className="col-md-12 mb-4" style={{ textAlign: "left" }}>
                    <label>Enter Property Meta Title</label>
                    <input
                      type="text"
                      placeholder="Enter Meta title"
                      className="form-control"
                      value={seoTitle}
                      onChange={(e) => setSeoTitle(e.target.value)}
                    />
                    {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                  </div>
                  <div className="col-md-12 mb-4" style={{ textAlign: "left" }}>
                    <label>Enter Property Meta Keywords</label>
                    <div className="tags-input">
                      {/* <ul className="custom-tags">
                                {tags?.map((tag, index) => (
                                    <li key={index} className="tag">
                                    <span className='tag-title'>{tag}</span>
                                    <i
                                        className="tag-close-icon"
                                        onClick={() => removeTags(index)}
                                    >
                                        x
                                    </i>
                                    </li>
                                ))}
                                </ul> */}
                      <input
                        type="text"
                        // onKeyUp={(event) => addTags(event)}
                        placeholder="Press enter to add tags"
                        value={tags}
                        onChange={(e) => setTags(e.target.value)}
                      />
                    </div>
                    {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                  </div>
                  <div className="col-md-12 mb-4" style={{ textAlign: "left" }}>
                    <label>Enter Property Meta Description</label>
                    <input
                      type="text"
                      placeholder="Enter Meta Description"
                      className="form-control"
                      value={seoDescription}
                      onChange={(e) => setSeoDescription(e.target.value)}
                    />
                    {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal4"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Property Details
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body add-property-modal">
              <div className="row admin-property-add">
                <div className="col-md-4 mb-4">
                  <label>Select Builder</label>
                  <select
                    className="form-control"
                    value={builder}
                    onChange={(e) => setBuilder(e.target.value)}
                  >
                    <option disabled selected>
                      Select Builder
                    </option>
                    {builderList?.map((data, index) => {
                      return (
                        <option key={index} value={data.id}>
                          {data.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-md-4 mb-4">
                  <label>Select Type</label>
                  <select
                    className="form-control"
                    value={typeArr}
                    onChange={(e) => setTypeArr(e.target.value)}
                  >
                    <option disabled selected>
                      Select Type
                    </option>
                    {typeList?.map((data, index) => {
                      return (
                        <option key={index} value={data.name}>
                          {data.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-md-4 mb-4">
                  <label>Property Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Property Image</label>
                  <input
                    type="file"
                    className="form-control"
                    placeholder="Enter Property Image"
                    onChange={imageUpload1}
                  />
                  <img
                    id="output_image"
                    alt="your image"
                    style={{
                      height: "100px",
                      width: "100px",
                      marginTop: "10px",
                      objectFit: "cover",
                      display: "none",
                    }}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Property Banner Image</label>
                  <input
                    type="file"
                    className="form-control"
                    placeholder="Enter Property Image"
                    onChange={imageUpload0}
                  />
                  <img
                    id="output_banner_image"
                    alt="your image"
                    style={{
                      height: "100px",
                      width: "100px",
                      marginTop: "10px",
                      objectFit: "cover",
                      display: "none",
                    }}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Enter Property Brochure Image</label>
                  <input
                    type="file"
                    className="form-control"
                    placeholder="Enter Property Image"
                    onChange={imageUpload11}
                  />
                  <img
                    id="output_brochure_image"
                    alt="your image"
                    style={{
                      height: "100px",
                      width: "100px",
                      marginTop: "10px",
                      objectFit: "cover",
                      display: "none",
                    }}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Enter Property Video</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Video Link"
                    value={propertyVideo}
                    onChange={(e) => setPropertyVideo(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Gallery Images</label>
                  <br />
                  <button
                    className="btn btn-danger"
                    data-toggle="modal"
                    data-target="#exampleModal5"
                  >
                    Upload
                  </button>
                </div>
                <div className="col-md-4 mb-4">
                  <label>Floor Plans Images</label>
                  <br />
                  <button
                    className="btn btn-danger"
                    data-toggle="modal"
                    data-target="#exampleModal12"
                  >
                    Upload
                  </button>
                </div>
                <div className="col-md-4 mb-4">
                  <label>Enter Floor Type</label>
                  <br />
                  <button
                    className="btn btn-danger"
                    data-toggle="modal"
                    data-target="#exampleModal9"
                  >
                    Upload
                  </button>
                  {/* <input type="file" className="form-control" placeholder="Enter Floor Plans Image" onChange={imageUpload3} />
                                    <img id="output1" alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', display: 'none' }} /> */}
                </div>
                <div className="col-md-4 mb-4">
                  <label>Min Price</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Price"
                    value={price}
                    onChange={(e) => setMinPrice(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Max Price</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Price"
                    value={max_price}
                    onChange={(e) => setMaxPrice(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>No of Bedrooms</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Bedrooms"
                    value={beds}
                    onChange={(e) => setBeds(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>No of Bathrooms</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Bathrooms"
                    value={bath}
                    onChange={(e) => setBath(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Property Address</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Enter City</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Address"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Enter State</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Address"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Parking Facility</label>
                  <select
                    className="form-control"
                    value={parking}
                    onChange={(e) => setParking(e.target.value)}
                  >
                    <option disabled selected>
                      Parking Available
                    </option>
                    <option value="Y">Yes</option>
                    <option value="N">No</option>
                  </select>
                </div>
                <div className="col-md-4 mb-4">
                  <label>Property Min Size (Squ.. Feet)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Size"
                    value={min_area}
                    onChange={(e) => setMinArea(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Property Max Size (Squ.. Feet)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Size"
                    value={max_area}
                    onChange={(e) => setMaxArea(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Property Status</label>
                  <select
                    className="form-control"
                    value={propertyStatus}
                    onChange={(e) => setPropertyStatus(e.target.value)}
                  >
                    <option disabled selected>
                      Select Status
                    </option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
                <div className="col-md-4 mb-4">
                  <label> Recent Property Section</label>
                  <select
                    className="form-control"
                    value={propertyRecentSection}
                    onChange={(e) => setPropertyRecentSection(e.target.value)}
                  >
                    <option disabled selected>
                      Recent Property
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
                <div className="col-md-4 mb-4">
                  <label> Popular Property Section</label>
                  <select
                    className="form-control"
                    value={propertyPopularSection}
                    onChange={(e) => setPropertyPopularSection(e.target.value)}
                  >
                    <option disabled selected>
                      Popular Property
                    </option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
                <div className="col-md-12 mb-3" style={{ textAlign: "left" }}>
                  <label> Property Short Description</label>
                  <textarea
                    maxLength="255"
                    id="text-lim"
                    className="form-control"
                    placeholder="Enter Description"
                    value={shortDesc}
                    onChange={(e) => {
                      setShortDesc(e.target.value);
                      getCharLength(e);
                    }}
                  ></textarea>
                  <p style={{ color: "red", marginBottom: "0" }}>
                    Max Characters {charValue}/255
                  </p>
                </div>
                <div className="col-md-12 mb-4" style={{ textAlign: "left" }}>
                  <label>Enter Property Details</label>
                  <ReactQuill
                    theme="snow"
                    value={pdetails}
                    onChange={(value) => setPDetails(value)}
                  />
                  {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                </div>
                <div className="col-md-12 mb-4" style={{ textAlign: "left" }}>
                  <label>Enter Property Meta Title</label>
                  <input
                    type="text"
                    placeholder="Enter Meta title"
                    className="form-control"
                    value={seoTitle}
                    onChange={(e) => setSeoTitle(e.target.value)}
                  />
                  {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                </div>
                <div className="col-md-12 mb-4" style={{ textAlign: "left" }}>
                  <label>Enter Property Meta Keywords</label>
                  <input
                    type="text"
                    placeholder="Enter Meta title"
                    className="form-control"
                    value={tags}
                    onChange={(e) => setTags(e.target.value)}
                  />
                  {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                </div>
                <div className="col-md-12 mb-4" style={{ textAlign: "left" }}>
                  <label>Enter Property Meta Description</label>
                  <input
                    type="text"
                    placeholder="Enter Meta title"
                    className="form-control"
                    value={seoDescription}
                    onChange={(e) => setSeoDescription(e.target.value)}
                  />
                  {/* <textarea className="form-control" placeholder="Enter Description" value={pdetails} onChange={(e) => setPDetails(e.target.value)} ></textarea> */}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={editForm}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal2"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Property Images
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                {appendDiv.map((data, key) => {
                  return (
                    // <button className="btn btn-danger remove-btn">-</button>
                    <div className="col-md-4 copy-div mb-3">
                      <input
                        className="form-control imageUpload2"
                        type="file"
                        id="myfile"
                        name="myfile"
                        onChange={imageUpload2}
                      />
                      <br />
                      <img
                        className="upload-img"
                        id={"output" + key + 20}
                        src={"https://api.divinebricks.com" + attachment}
                        alt="your image"
                      />
                    </div>
                  );
                })}
                {/* <div className="col-md-4 copy-div"> */}
                {/* <input className='form-control' type="file" id="myfile" name="myfile" required onChange={imageUpload2} />
                                    <img id="output1" src={'https://api.divinebricks.com' + attachment} alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', visibility: seeImg2 }} /> */}
                {/* </div> */}
              </div>
              <div style={{ textAlign: "left", marginTop: "20px" }}>
                <button className="btn btn-danger" onClick={addDiv}>
                  + Add Images
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal7"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Floor Plan Images
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                {appendDiv1.map((data, key) => {
                  return (
                    // <button className="btn btn-danger remove-btn">-</button>
                    <>
                      <div className="col-md-4 copy-div mb-3">
                        <input
                          className="form-control imageUpload2"
                          type="file"
                          id="myfile"
                          name="myfile"
                          onChange={imageUpload16}
                        />
                        <br />
                        <select
                          className="form-control"
                          onChange={handleOnChange}
                        >
                          <option disabled selected>
                            Select Type
                          </option>
                          <option value="TypeA">TypeA</option>
                          <option value="TypeB">TypeB</option>
                          <option value="TypeC">TypeC</option>
                          <option value="TypeD">TypeD</option>
                        </select>
                        <img
                          className="upload-img"
                          id={"output" + key + 80}
                          src={"https://api.divinebricks.com" + attachment}
                          alt="your image"
                        />
                      </div>
                      {/* <div><button className="btn btn-primary" onClick={addFloorType}>Save</button></div> */}
                    </>
                  );
                })}
                {/* <div className="col-md-4 copy-div"> */}
                {/* <input className='form-control' type="file" id="myfile" name="myfile" required onChange={imageUpload2} />
                                    <img id="output1" src={'https://api.divinebricks.com' + attachment} alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', visibility: seeImg2 }} /> */}
                {/* </div> */}
              </div>
              <div style={{ textAlign: "left", marginTop: "20px" }}>
                <button className="btn btn-danger" onClick={addDiv1}>
                  + Add Images
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal8"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Add Floor Type
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                {appendDiv2.map((data, key) => {
                  return (
                    // <button className="btn btn-danger remove-btn">-</button>
                    <>
                      <div className="col-md-4 copy-div mb-3">
                        <select
                          className="form-control mb-1"
                          name="name"
                          onChange={handleFloorArray}
                        >
                          <option disabled selected>
                            Select No of Bedroom
                          </option>
                          <option value="1">1 Bedroom</option>
                          <option value="1.5">1.5 Bedroom</option>
                          <option value="2">2 Bedrooms</option>
                          <option value="2.5">2.5 Bedrooms</option>
                          <option value="3">3 Bedrooms</option>
                          <option value="4">4 Bedrooms</option>
                          <option value="5">5 Bedrooms</option>
                          <option value="6">6 Bedrooms</option>
                          <option value="7">7 Bedrooms</option>
                        </select>
                        <input
                          type="text"
                          className="form-control mb-1"
                          name="type"
                          placeholder="Enter Type"
                          onChange={handleFloorArray}
                        />
                        <input
                          type="text"
                          className="form-control mb-1"
                          name="area"
                          placeholder="Enter Area Size"
                          onChange={handleFloorArray}
                        />
                        <input
                          type="text"
                          className="form-control mb-1"
                          name="price"
                          placeholder="Enter Price"
                          onChange={handleFloorArray}
                        />
                        <button className="bt btn-danger" onClick={saveArr}>
                          Save
                        </button>
                      </div>
                      {/* <div><button className="btn btn-primary" onClick={addFloorType}>Save</button></div> */}
                    </>
                  );
                })}
                {/* <div className="col-md-4 copy-div"> */}
                {/* <input className='form-control' type="file" id="myfile" name="myfile" required onChange={imageUpload2} />
                                    <img id="output1" src={'https://api.divinebricks.com' + attachment} alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', visibility: seeImg2 }} /> */}
                {/* </div> */}
              </div>
              <div style={{ textAlign: "left", marginTop: "20px" }}>
                <button className="btn btn-danger" onClick={addDiv2}>
                  + Add More
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={handleFloorTypes}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal9"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Floor Type
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                {oldPropertyBedroom?.map((data, index) => {
                  // setUpdateBedroomArea(data?.area)
                  // setUpdateBedroomName(data?.name)
                  // setUpdateBedroomType(data?.type)
                  // setUpdateBedroomPrice(data?.price)
                  return (
                    <div
                      className="col-md-4 mb-3"
                      style={{ textAlign: "left" }}
                      key={data?.id}
                      id={data?.id}
                    >
                      {/* <select className="form-control mb-1" name="name" value={data.name} onChange={handleFloorArray}>
                                                <option disabled selected>Select No of Bedroom</option>
                                                <option value='1'>1 Bedroom</option>
                                                <option value='1.5'>1.5 Bedroom</option>
                                                <option value='2'>2 Bedrooms</option>
                                                <option value='2.5'>2.5 Bedrooms</option>
                                                <option value='3'>3 Bedrooms</option>
                                                <option value='4'>4 Bedrooms</option>
                                                <option value='5'>5 Bedrooms</option>
                                                <option value='6'>6 Bedrooms</option>
                                                <option value='7'>7 Bedrooms</option>
                                            </select> */}
                      <label style={{ fontSize: "12px", fontWeight: "400" }}>
                        Current No of Bedrooms : {data?.name}
                      </label>
                      <input
                        key={index}
                        type="text"
                        className="form-control mb-1"
                        name="name"
                        placeholder="Enter Bedrooms"
                        onChange={(e) => setUpdateBedroomName(e.target.value)}
                      />
                      <label style={{ fontSize: "12px", fontWeight: "400" }}>
                        Current Type : {data?.type}
                      </label>
                      <input
                        type="text"
                        className="form-control mb-1"
                        name="type"
                        placeholder="Enter Type"
                        onChange={(e) => setUpdateBedroomType(e.target.value)}
                      />
                      <label style={{ fontSize: "12px", fontWeight: "400" }}>
                        Current Area : {data?.area}
                      </label>
                      <input
                        type="text"
                        className="form-control mb-1"
                        name="area"
                        placeholder="Enter Area Size"
                        onChange={(e) => setUpdateBedroomArea(e.target.value)}
                      />
                      <label style={{ fontSize: "12px", fontWeight: "400" }}>
                        Current Price : {data?.price}
                      </label>
                      <input
                        type="text"
                        className="form-control mb-1"
                        name="price"
                        placeholder="Enter Price"
                        onChange={(e) => setUpdateBedroomPrice(e.target.value)}
                      />
                      <div style={{ textAlign: "left" }}>
                        <button
                          className="btn btn-primary"
                          onClick={() => updateBedrooms(data.id)}
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  );
                })}
                {appendDiv2.map((data, key) => {
                  return (
                    // <button className="btn btn-danger remove-btn">-</button>
                    <>
                      <div className="col-md-4 copy-div mb-3">
                        <select
                          className="form-control mb-1"
                          name="name"
                          onChange={handleFloorArray}
                        >
                          <option disabled selected>
                            Select No of Bedroom
                          </option>
                          <option value="1">1 Bedroom</option>
                          <option value="1.5">1.5 Bedroom</option>
                          <option value="2">2 Bedrooms</option>
                          <option value="2.5">2.5 Bedrooms</option>
                          <option value="3">3 Bedrooms</option>
                          <option value="4">4 Bedrooms</option>
                          <option value="5">5 Bedrooms</option>
                          <option value="6">6 Bedrooms</option>
                          <option value="7">7 Bedrooms</option>
                        </select>
                        <input
                          type="text"
                          className="form-control mb-1"
                          name="type"
                          placeholder="Enter Type"
                          onChange={handleFloorArray}
                        />
                        <input
                          type="text"
                          className="form-control mb-1"
                          name="area"
                          placeholder="Enter Area Size"
                          onChange={handleFloorArray}
                        />
                        <input
                          type="text"
                          className="form-control mb-1"
                          name="price"
                          placeholder="Enter Price"
                          onChange={handleFloorArray}
                        />
                        <button className="bt btn-danger" onClick={saveArr}>
                          Save
                        </button>
                      </div>
                      {/* <div><button className="btn btn-primary" onClick={addFloorType}>Save</button></div> */}
                    </>
                  );
                })}
                {/* <div className="col-md-4 copy-div"> */}
                {/* <input className='form-control' type="file" id="myfile" name="myfile" required onChange={imageUpload2} />
                                    <img id="output1" src={'https://api.divinebricks.com' + attachment} alt="your image" style={{ height: '100px', width: '100px', marginTop: '10px', objectFit: 'cover', visibility: seeImg2 }} /> */}
                {/* </div> */}
              </div>
              <div style={{ textAlign: "left", marginTop: "20px" }}>
                <button className="btn btn-danger" onClick={addDiv2}>
                  + Add More
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
                onClick={handleFloorTypes}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal5"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Property Gallery Images
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                {oldGalleryImages?.map((data) => {
                  return (
                    <div className="col-md-4 mb-3" key={data.id}>
                      <img
                        src={"https://api.divinebricks.com" + data.img_url}
                        style={{ width: "100%", maxHeight: "140px" }}
                      />
                      <button
                        key={data.id}
                        id={data.id}
                        onClick={(e) => handleGalleryId(data)}
                        style={{ border: "none", borderRadius: "4px" }}
                      >
                        <input
                          key={data.id}
                          type="file"
                          className="form-control"
                          id="update-image-test"
                          onChange={imageUpload10}
                        />
                      </button>
                    </div>
                  );
                })}
                {appendDiv.map((data, key) => {
                  return (
                    //
                    <div className="col-md-4 copy-div mb-3">
                      <input
                        className="form-control imageUpload2"
                        type="file"
                        id="myfile"
                        name="myfile"
                        onChange={imageUpload20}
                      />
                      <br />{" "}
                      <img
                        className="upload-img"
                        id={"output" + key + 100}
                        src={"https://api.divinebricks.com" + attachment}
                        alt="your image"
                      />
                    </div>
                  );
                })}
              </div>
              <div style={{ textAlign: "left", marginTop: "20px" }}>
                <button className="btn btn-danger" onClick={addDiv}>
                  + Add Images
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal12"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Property Floor Plan Images
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                {oldFloorPlanImages?.map((data) => {
                  return (
                    <div className="col-md-4 mb-3">
                      <img
                        src={"https://api.divinebricks.com" + data.img_url}
                        style={{ width: "100%", maxHeight: "140px" }}
                      />
                      <button
                        onClick={() => {
                          setGalleryId(data?.id);
                          setGalleryName(data?.name);
                        }}
                        style={{ border: "none", borderRadius: "4px" }}
                      >
                        <input
                          type="file"
                          className="form-control"
                          id="update-floor-id"
                          placeholder="Enter Floor Plans Image"
                          onChange={imageUpload9}
                        />
                      </button>
                    </div>
                  );
                })}
                {appendDiv.map((data, key) => {
                  return (
                    //
                    <div className="col-md-4 copy-div mb-3">
                      <input
                        className="form-control imageUpload2"
                        type="file"
                        id="myfile"
                        name="myfile"
                        onChange={imageUpload21}
                      />
                      <br />{" "}
                      <img
                        className="upload-img"
                        id={"output" + key + 100}
                        src={"https://api.divinebricks.com" + attachment}
                        alt="your image"
                      />
                    </div>
                  );
                })}
              </div>
              <div style={{ textAlign: "left", marginTop: "20px" }}>
                <button className="btn btn-danger" onClick={addDiv}>
                  + Add Images
                </button>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModal6"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                View Property Details
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body add-property-modal">
              <div className="row admin-property-add">
                <div className="col-md-4 mb-4">
                  <label>Property Image</label>
                  <br />
                  <img
                    src={"https://api.divinebricks.com" + propertyImg}
                    style={{ width: "100px", height: "100px" }}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Property Banner Image</label>
                  <br />
                  <img
                    src={"https://api.divinebricks.com" + propertyBannerImg}
                    style={{ width: "100px", height: "100px" }}
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Gallery Images</label>
                  <br />
                  <div
                    id="carouselExampleControls"
                    className="carousel slide"
                    data-ride="carousel"
                  >
                    <div className="carousel-inner">
                      {oldGalleryImages?.map((data1, key) => {
                        return (
                          <div
                            class={
                              key == 0
                                ? "carousel-item active"
                                : "carousel-item"
                            }
                          >
                            <img
                              src={
                                "https://api.divinebricks.com" + data1?.img_url
                              }
                              alt=""
                              style={{ width: "100%", height: "100px" }}
                            />
                          </div>
                        );
                      })}
                    </div>
                    <a
                      className="carousel-control-prev"
                      href="#carouselExampleControls"
                      role="button"
                      data-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span className="sr-only">Previous</span>
                    </a>
                    <a
                      className="carousel-control-next"
                      href="#carouselExampleControls"
                      role="button"
                      data-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span className="sr-only">Next</span>
                    </a>
                  </div>
                </div>
                <div className="col-md-4 mb-4">
                  <label>Floor Plans Images</label>
                  <br />
                  <div
                    id="carouselExampleControls1"
                    className="carousel slide"
                    data-ride="carousel"
                  >
                    <div className="carousel-inner">
                      {oldFloorPlanImages?.map((data1, key) => {
                        return (
                          <div
                            class={
                              key == 0
                                ? "carousel-item active"
                                : "carousel-item"
                            }
                          >
                            <img
                              src={
                                "https://api.divinebricks.com" + data1?.img_url
                              }
                              alt=""
                              style={{ width: "100%", height: "100px" }}
                            />
                          </div>
                        );
                      })}
                    </div>
                    <a
                      className="carousel-control-prev"
                      href="#carouselExampleControls1"
                      role="button"
                      data-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span className="sr-only">Previous</span>
                    </a>
                    <a
                      className="carousel-control-next"
                      href="#carouselExampleControls1"
                      role="button"
                      data-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span className="sr-only">Next</span>
                    </a>
                  </div>
                </div>
                <div className="col-md-4 mb-4">
                  <label>No of Bedrooms</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Bedrooms"
                    value={beds}
                    readOnly
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>No of Bathrooms</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Bathrooms"
                    value={bath}
                    readOnly
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Address</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Size"
                    value={address}
                    readOnly
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>City</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Size"
                    value={city}
                    readOnly
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>State</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Size"
                    value={state}
                    readOnly
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Min Property Size (Squ.. Feet)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Size"
                    value={min_area}
                    readOnly
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Max Property Size (Squ.. Feet)</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Size"
                    value={max_area}
                    readOnly
                  />
                </div>
                <div className="col-md-4 mb-4">
                  <label>Parking</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Property Size"
                    value={parking}
                    readOnly
                  />
                </div>
                <div className="col-md-12 mb-4" style={{ textAlign: "left" }}>
                  <label>Property Details</label>
                  <textarea
                    className="form-control"
                    placeholder="Enter Description"
                    value={pdetails}
                    readOnly
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PropertiesList;
